const initialState = {
  fullname: "",
  email: "",
  koordinator: "",
};

const authKoorProduktifReducer = (state = initialState, action) => {
  let { type, data } = action;

  switch (type) {
    case "SET_IDENTITY_KOORDINATOR_PRODUKTIF":
      return {
        ...state,
        fullname: data.fullname,
        email: data.email,
        koordinator: data.koordinator,
      };
    default:
      return state;
  }
};

export default authKoorProduktifReducer;
